<template>
  <div class="game_item" @click="playGame">
    <div class="game_img">
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--theme-btm-bg-color);
        "
      >
        <svg-icon
          style="
            width: 100%;
            height: 100%;
            color: var(--theme-game-card-ddt_icon);
          "
          icon-class="img_mryx_card--svgSprite:all"
        />
      </div>
      <div loading="loading">
        <img v-if="isLazy" class="conte_img" v-lazy="item.image" alt="" />
        <img v-else class="conte_img" :src="item.image" alt="" />
      </div>
      <div
        class="vyJOQO76ijmamNiW1_eF"
        v-if="$store.state.config.show_game_name && item.type != 'platform'"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
// favoriteGame
import { favoriteGame } from '@/apis/modules/home.js';
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'GameItem',
  props: {
    item: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'subgame'
    },
    category: {
      type: String,
      default: 'slot'
    },
    isLazy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      is_favorite: false,
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head'])
  },
  methods: {
    checkLogin() {
      if (!this.vuex_token_head) {
        if (this.rememberPassword && this.rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    favorite() {
      if (!this.checkLogin()) return false;
      favoriteGame({
        game_id: this.item.id,
        is_favorite: this.item.is_favorite == 0 ? 1 : 0
      }).then(({ code }) => {
        this.item.is_favorite = this.item.is_favorite == 0 ? 1 : 0;
        this.is_favorite = this.item.is_favorite;
        // this.is_favorite=
      });
    },
    playGame(id) {
      if (this.item.is_maintenance) {
        Toast.fail({
          message: this.myLineBreaks(this.$t('_home._tis')),
          duration: 1000
        });
        return false;
      }
      if (this.item.type != 'platform') {
        if (!this.checkLogin()) return false;
        if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 1
        ) {
          // 余额最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.balance_coin
          ) {
            Toast.fail({
              message:this.myLineBreaks(
                this.$t('_home._balanceLess1') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._balanceLess2')
              ),
              duration: 1500
            });
            return false;
          }
        } else if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 2
        ) {
          // 充值最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.recharge_total
          ) {
            Toast.fail({
              //message:this.$t('_home._rechargeLess1'),
              message:this.myLineBreaks(
                this.$t('_home._rechargeLess2') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._rechargeLess3')
              ),
              duration: 1500
            });
            return false;
          }
        }
      }
      // platform平台（点击跳游戏列表），
      // game游戏（点击后跳到玩游戏）
      if (this.item.type == 'platform') {
        // webview
        //
        if (this.type == 'home') {
          this.$router.push({
            name: 'subgame',
            query: {
              id: this.item.id,
              code: this.item.code,
              category: this.item.category || 'slot'
            }
          });
        }
        return false;
      } else {
        this.$router.push({
          name: 'webview',
          query: {
            id: this.item.id,
            category: this.item.category
            // =demo
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.game_item {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
}

.game_item {
  --card-benchmark: 1.66rem;
  --advertisement-box-width: var(--card-benchmark);
  --advertisement-box-height: calc(var(--card-benchmark) * 1.33);
  --advertisement-box-border-width: 0;
  --advertisement-box-border-color: var(--theme-game-lobby-border);
  --advertisement-box-border-radius: 0.2rem;
  --game-platform-name-height: calc(var(--card-benchmark) * 0.25);
  --game-platform-name-padding: 0 calc(var(--card-benchmark) * 0.05)
    calc(var(--card-benchmark) * 0.05);
  --game-platform-name-font-size: calc(var(--card-benchmark) * 0.113);
  --label-game-status-width: calc(var(--card-benchmark) * 0.2);
  --label-game-status-height: calc(var(--card-benchmark) * 0.15);
  --favorited-icon-top: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-right: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-bottom: initial;
  --favorited-icon-left: initial;
  --favorited-icon-side: calc(var(--card-benchmark) * 0.206);
  --click-arean-expand-size: -0.06rem;
}
.game_title {
  border-radius: 0;
  text-align: center;
  width: 100%;
}
.game_img {
  background-color: var(--theme-bg-color);
  align-items: center;
  border-color: var(--advertisement-box-border-color);
  border-style: solid;
  border-width: var(--advertisement-box-border-width);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  border-radius: var(--advertisement-box-border-radius);
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  width: var(--advertisement-box-width);
  height: var(--advertisement-box-height);
  overflow: hidden;
  margin: var(--cardColSpacing) var(--cardColSpacing) 0 var(--cardColSpacing);
}
.conte_img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.vyJOQO76ijmamNiW1_eF {
  /* line-height: 2.694; */
  webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  text-align: center;
  align-items: center;
  text-overflow: ellipsis;
  text-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.3);
  vertical-align: middle;
  -ms-flex-pack: center;
  word-wrap: break-word;
  color: var(--theme-text-color-task-btn);
  display: -ms-flexbox;
  display: flex;
  font-size: var(--game-platform-name-font-size);
  height: var(--game-platform-name-height);
  justify-content: center;
  margin-bottom: var(--game-platform-name-margin-bottom);
  padding: var(--game-platform-name-padding);
  width: 100%;
  position: relative;
  position: absolute;
  bottom: 0;
  z-index: 9;
}
</style>
